<div class="sale-horse-internal-note-popup">
  <form name="internalNoteForm"
        (ngSubmit)="formSubmit()"
        [formGroup]="internalNoteForm"
        novalidate>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Internal Notes - HIP {{data?.lot}} <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>--></h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="table-responsive data-grid sticky-header-table" #table>
        <table mat-table [dataSource]="dataSource" class="table" [hidden]="!isListMode">

          <ng-container matColumnDef="notes">
            <th mat-header-cell class="notes-heading w-35 ps-0" *matHeaderCellDef> Notes </th>
            <td mat-cell *matCellDef="let element" class="ps-0"> {{element.notes}} </td>
          </ng-container>

          <ng-container matColumnDef="user">
            <th mat-header-cell class="notes-heading w-25 ps-0 text-center" *matHeaderCellDef> User </th>
            <td mat-cell *matCellDef="let element" class="ps-0 text-center"> {{element.createdByUser.name}} </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell class="notes-heading w-25 ps-0 text-center" *matHeaderCellDef> Date/Time </th>
            <td mat-cell *matCellDef="let element" class="ps-0 text-center"> {{element.createdDate | date : getDefaultDateFormat()}} </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell class="ps-0 w-15 text-center" *matHeaderCellDef>
              Action
            </th>
            <td mat-cell *matCellDef="let element" class="p-2">
              <button type="button" (click)="getNote(element.id)" class="btn btn-outline-primary btn-sm mt-1"><i class="far fa-edit"></i></button>
              <button type="button" (click)="deleteSaleHorseNote(element.id)" class="btn btn-outline-danger btn-sm ms-md-1 mt-1"><i class="fa fa-trash"></i></button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns$.value"></tr>
          <tr mat-row
              *matRowDef="
            let row;
            columns: displayedColumns$.value;
            let vetUserIndex = index
          "
              class="pointer"></tr>
        </table>
        <!--<div class="row" *ngIf="isLoader">
          <div class="col-md-12 text-center">
            Loading <i class="fa fa-spinner fa-spin"></i>
          </div>
        </div>-->
      </div>
      <div [hidden]="isListMode">
        <textarea id="note"
                  class="form-control"
                  formControlName="note"
                  rows="8"></textarea>
        <span class="text-danger"
              *ngIf="
				submitted && internalNoteForm.hasError('required', 'note')
				">
          First Name is required!
        </span>
      </div>
    </div>
    <div class="modal-footer">
      <div class="button-group">
        <button [hidden]="isListMode" type="button" class="btn btn-secondary btn-sm me-1" (click)="cancel();"><i class="fa fa-times"></i> Cancel</button>
        <button [hidden]="isListMode" type="submit" class="btn btn-primary btn-sm" (click)="formSubmit()"><i class="fa fa-save"></i> Submit</button>
        <button [hidden]="!isListMode" type="button" class="btn btn-primary btn-sm" (click)="add();"><i class="fa fa-plus"></i> Add</button>
      </div>
    </div>
  </form>
</div>
